<div class="flex flex-col items-center px-6 py-20 mx-auto md:h-screen pt:mt-0">
    <div class="w-full max-w-xl rounded-lg text-dark-blue dark:text-white">
        <h2 class="text-4xl text-[2rem]">
            Sign in to Hagile 
        </h2>
        <hg-auth-options></hg-auth-options>
   </div>
</div>